import React from 'react';
// import moment from 'moment-timezone';
import { Level, Title } from 'rbx';
import styled from 'styled-components';
import { SubHeading } from '../../../components/elements';

const Wrapper = styled.div`
  padding: 1rem;
  .level:not(:last-child) {
    margin-bottom: 0;
  }
`;

const Header = ({ place }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title size={2} className="is-capitalized">
          {place.name}
        </Title>
      </Level.Item>
    </Level>
    <React.Fragment>
      {/* <SubHeading className="is-size-2">{user.email}</SubHeading> */}
      <SubHeading className="is-size-2">
        {place.address_line_1}, {place.city}, {place.state}, {place.post_code}
      </SubHeading>
    </React.Fragment>
  </Wrapper>
);

export default Header;
